export const OPTIMIZED_RESIZE = 'optimizedResize';
